import type { Content, EnExperienceViewModel } from '@/models/enExperience';

/**
 * Experience専用のexperienceIds抽出ユーティリティ
 * EnExperienceViewModelからArticleSectionを抽出し、その中のexperienceIdsを取得する
 */
export const useExtractExperienceIds = (experienceCms: Ref<EnExperienceViewModel>) => {
  const experienceIds = computed(() => {
    const contents = experienceCms.value?.contents ?? [];
    const articleSections = contents.filter((content): content is Content => content.fieldId === 'articleSection' && content.columns !== undefined);

    const allExperienceIds: string[] = [];

    for (const section of articleSections) {
      for (const column of section.columns ?? []) {
        for (const content of column.contents) {
          // mediumExps, smallExps, largeExpsからexperienceIdsを抽出
          if ((content.fieldId === 'mediumExps' || content.fieldId === 'smallExps' || content.fieldId === 'largeExps') && 'experiences' in content && Array.isArray(content.experiences)) {
            const ids = content.experiences.map((exp) => (exp?.id != null ? String(exp.id) : '')).filter((id): id is string => id.length > 0);
            allExperienceIds.push(...ids);
          }
        }
      }
    }

    // 重複を除去してユニークなIDのみ返す
    return [...new Set(allExperienceIds)];
  });

  return { experienceIds };
};
